import PartnerTicketsContainer from './tickets-container';

export default PartnerTicketsContainer;
